import ViralAPIs from '@/API/viral-api'

export default {
  namespaced: true,
  state: {
    info: null,
    fetched: false,
  },
  getters: {
    info: (state: any) => state.info,
    existed: (state: any) => state.info?.is_existed,
    verified: (state: any) => !!state.info?.verified_at,
    canEnableViral: (state: any, getters: any, rootState: any, rootGetters: any) => rootGetters['businessTypes/hasFoodMenu'],
  },
  mutations: {
    SET_VIRAL_INFO(state: any, info: unknown) {
      state.fetched = !!info
      state.info = info
    },
  },
  actions: {
    async FETCH_INFO(context: any, force = false) {
      if (context.state.fetched && !force) return context.state.info
      try {
        const info = await ViralAPIs.info(context.rootGetters['branches/currentBranchId'])
        context.commit('SET_VIRAL_INFO', info)
      } catch (e) {
        context.commit('SET_VIRAL_INFO', null)
      }
      return context.state.info
    },
    async GET_STATUS(context: any) {
      const info = context.getters.info ?? {}
      const status = await ViralAPIs.getStatus(context.rootGetters['branches/currentBranchId'])
      context.commit('SET_VIRAL_INFO', { ...info, status })
      return info
    },
  },
}
